import { c as _c } from "react/compiler-runtime";
import { ItemLegendAxisValues } from './item-legend-axis-values';
const MobileAxisYValues = Array.from({
  length: 9
}).map((_, i) => ({
  width: [13, 26, 16, 25, 16, 25, 16, 25, 16][i]
}));
function LegendAxisYItems() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col justify-end gap-4 md:hidden">{MobileAxisYValues.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex">{t0}<div className="hidden flex-col justify-end gap-2.5 md:flex lg:gap-3 xl:gap-5">{MobileAxisYValues.map(_temp2)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp2(__0, index_0) {
  return <div key={index_0} className="flex"><ItemLegendAxisValues width={48} /></div>;
}
function _temp(_, index) {
  return <div key={index} className="flex"><ItemLegendAxisValues width={16} /></div>;
}
export { LegendAxisYItems };